import "core-js/modules/es.array.push.js";
import { showToast, closeToast, showLoadingToast } from 'vant';
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => []
    },
    startPosition: {
      type: Number,
      default: 0
    }
  },
  components: {},
  emits: ['update:show'],
  data() {
    return {
      visible: this.show,
      showAction: false,
      position: 0,
      actions: [{
        name: this.$t('cfmoto.savePicture'),
        value: 'writePhotosAlbum'
      }],
      paramOptions: {
        images: this.images,
        startPosition: this.startPosition
      }
    };
  },
  computed: {
    isApp() {
      return true;
    },
    styles() {
      const safeAreaInsetTop = window.cfmoto.statusBarHeight();
      return {
        '--safe-area-inset-top': safeAreaInsetTop
      };
    },
    pressFunctions() {
      const images = this.paramOptions.images || [];
      return images.map((url, index) => e => {
        if (this.isApp) {
          this.position = index;
          this.showAction = true;
        }
      });
    }
  },
  methods: {
    getIndex(src) {
      return this.paramOptions.images.findIndex(itemSrc => itemSrc === src);
    },
    open(options = {}) {
      this.paramOptions = {
        ...this.paramOptions,
        ...options
      };
      this.visible = true;
    },
    handleClose() {
      if (this.paramOptions.onCancel) {
        this.paramOptions.onCancel();
      }
      this.visible = false;
    },
    onChange(index) {
      this.position = index;
    },
    onCancel() {},
    async onSelect(item, index) {
      try {
        if (item.value === 'writePhotosAlbum') {
          const url = this.paramOptions.images[this.position];
          if (!this.isApple) {}
          await new Promise((resolve, reject) => window.cfmoto.openAppAuthorizeSetting({
            name: 'writePhotosAlbum',
            success: resolve,
            fail: reject
          }));
          showLoadingToast({
            forbidClick: true,
            duration: 0,
            overlay: true,
            message: ''
          });
          const res = await new Promise(resolve => window.cfmoto.saveImageToPhotosAlbum({
            url,
            success: resolve,
            fail: resolve
          }));
          closeToast();
          if (res.errCode !== 200) {
            showToast(res.errMsg);
            return;
          }
          showToast(this.$t('cfmoto.saveSuccess'));
        }
      } catch (error) {
        // showToast(JSON.stringify(error));
        throw new Error(error);
      } finally {
        setTimeout(() => {
          this.showAction = false;
        }, 300);
      }
    }
  },
  created() {
    this.visible = this.show;
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  beforeUnmount() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  watch: {
    show(newValue) {
      this.visible = newValue;
    },
    visible: {
      immediate: true,
      handler(newValue) {
        this.$emit('update:show', newValue);
        if (newValue) {
          this.$router.push({
            query: {
              ...this.$route.query,
              previewImage: 'true'
            }
          });
        } else {
          this.$nextTick(() => {
            if (this.$route.query.previewImage) this.$router.back();
          });
        }
      }
    },
    images: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.paramOptions.images = newValue;
      }
    },
    startPosition: {
      immediate: true,
      handler(newValue) {
        this.paramOptions.startPosition = newValue;
      }
    }
  }
};